import { render, staticRenderFns } from "./DealInvoice.vue?vue&type=template&id=69980d34&scoped=true&"
import script from "./DealInvoice.vue?vue&type=script&lang=js&"
export * from "./DealInvoice.vue?vue&type=script&lang=js&"
import style0 from "./DealInvoice.vue?vue&type=style&index=0&id=69980d34&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69980d34",
  null
  
)

export default component.exports